import { Div, Ref } from '@tblabs/truffle';
import { Bar } from "./Bar";


export class BarChart extends Div
{
    constructor(value: Ref<number>)
    {
        super();
        this.DisplayInlineBlock();

        this.Append(
            new Bar(value, 1),
            new Bar(value, 2),
            new Bar(value, 3),
            new Bar(value, 4)
        );
    }
}
